import type { ReactNode } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { ChartSkeleton } from "@/components/shared/loading-skeleton";
import { EmptyState } from "@/components/shared/empty-state";
import { BarChart3 } from "lucide-react";

interface ChartCardProps {
  title: string;
  description?: string;
  isLoading?: boolean;
  isEmpty?: boolean;
  emptyMessage?: string;
  children: ReactNode;
}

export function ChartCard({ title, description, isLoading, isEmpty, emptyMessage, children }: ChartCardProps) {
  if (isLoading) {
    return <ChartSkeleton />;
  }

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
        {description ? <p className="text-xs text-muted-foreground">{description}</p> : null}
      </CardHeader>
      <CardContent>
        {isEmpty ? (
          <EmptyState icon={BarChart3} title="No data for this range" description={emptyMessage} />
        ) : (
          <div role="img" aria-label={title} className="h-64 w-full">
            {children}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
